import React from "react";
import PropTypes from "prop-types";
import SearchableSelect from "../common/SearchableSelect";

function ClientSettlementsReportForm({
  month,
  monthOptions,
  clientId,
  clientOptions,
  showDraft,
  showApproved,
  showNegativeBalanceOnly,
  showEmptyClients,
  onChange,
  onClearFilters,
}) {
  return (
    <div className="mb-4">
      <div className="form-row align-items-end">
        <div className="col-md-4">
          <SearchableSelect
            label="Miesiac"
            name="month"
            value={month}
            onChange={onChange}
            options={monthOptions}
            placeholder="Wybierz miesiac"
            isClearable={false}
          />
        </div>
        <div className="col-md-4">
          <SearchableSelect
            label="Klient"
            name="clientId"
            value={clientId}
            onChange={onChange}
            options={clientOptions}
            placeholder="Wszyscy"
            clearValue="all"
          />
        </div>
      </div>
      <div className="form-row align-items-end mt-2">
        <div className="col-md-auto">
          <div className="form-group">
            <button
              type="button"
              className={`btn btn-sm mr-2 ${showDraft ? "btn-info" : "btn-outline-secondary"}`}
              aria-pressed={showDraft}
              onClick={() => onChange({ target: { name: "showDraft", value: !showDraft } })}
            >
              Robocze
            </button>
            <button
              type="button"
              className={`btn btn-sm mr-2 ${showApproved ? "btn-info" : "btn-outline-secondary"}`}
              aria-pressed={showApproved}
              onClick={() => onChange({ target: { name: "showApproved", value: !showApproved } })}
            >
              Zatwierdzone
            </button>
            <button
              type="button"
              className={`btn btn-sm mr-2 ${showNegativeBalanceOnly ? "btn-danger" : "btn-outline-secondary"}`}
              aria-pressed={showNegativeBalanceOnly}
              onClick={() => onChange({ target: { name: "showNegativeBalanceOnly", value: !showNegativeBalanceOnly } })}
            >
              Tylko z niedoplata
            </button>
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary mr-2"
              aria-pressed={showEmptyClients}
              onClick={() => onChange({
                target: {
                  name: "showEmptyClients",
                  value: !showEmptyClients,
                },
              })}
            >
              {showEmptyClients ? "Ukryj pustych klientow" : "Pokaz tez pustych klientow"}
            </button>
            <button
              type="button"
              className="btn btn-sm btn-outline-dark"
              onClick={onClearFilters}
            >
              Wyczysc filtry
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

ClientSettlementsReportForm.propTypes = {
  month: PropTypes.string.isRequired,
  monthOptions: PropTypes.array.isRequired,
  clientId: PropTypes.string.isRequired,
  clientOptions: PropTypes.array.isRequired,
  showDraft: PropTypes.bool.isRequired,
  showApproved: PropTypes.bool.isRequired,
  showNegativeBalanceOnly: PropTypes.bool.isRequired,
  showEmptyClients: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onClearFilters: PropTypes.func.isRequired,
};

export default ClientSettlementsReportForm;
